import React, { useEffect } from "react";
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  AccordionIcon,
  Box,
  Checkbox,
} from "@chakra-ui/react";
import { useSubjectsCheckbox } from "../hooks/useSubjectsCheckbox";

const SubjectAccordion = ({
  subjects,
  updateField,
  defaultChecked,
}: {
  subjects: string[];
  updateField: (key: string, value: string | string[]) => void;
  defaultChecked?: boolean;
}) => {
  const [checkedSubjects, handleChange] = useSubjectsCheckbox(
    subjects,
    defaultChecked,
  ) as [string[], (e: React.ChangeEvent<HTMLInputElement>) => void];

  useEffect(() => {
    updateField("subjects", checkedSubjects);
  }, [checkedSubjects]);

  return (
    <Accordion
      allowMultiple
      border="1px solid"
      borderColor={"gray.200"}
      rounded="md"
    >
      <AccordionItem border="none">
        <h2>
          <AccordionButton _expanded={{ bg: "gray.200" }}>
            <Box flex="1" textAlign="left">
              {checkedSubjects.length >= 1
                ? `${checkedSubjects.length} subject(s) selected`
                : "Select subject(s)"}
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel py="0rem">
          <Box py="1rem">
            {subjects.map((subject, index) => (
              <Checkbox
                key={index}
                value={subject.toLowerCase()}
                textTransform="capitalize"
                mr="2rem"
                onChange={handleChange}
                defaultChecked={defaultChecked}
              >
                {subject}
              </Checkbox>
            ))}
          </Box>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default SubjectAccordion;
